<template>
  <v-card>
    <v-card-title>
      {{ $t('guarantees.prolongateTitle', guarantee) }}
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <vf-date-input
            v-model="form.expiryDate"
            :label="$t('guarantees.expiryDate')"
            dense
            outlined
            @change="$v.form.expiryDate.$touch()"
            :error-messages="errorMessages('expiryDate')"
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="form.documentUrl"
            :label="$t('guarantees.documentUrl')"
            dense
            outlined
            @change="$v.form.documentUrl.$touch()"
            :error-messages="errorMessages('documentUrl')"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="form.comment"
            :label="$t('guarantees.comment')"
            dense
            outlined
            counter="128"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        rounded
        dark
        dense
        outlined
        color="primary"
        @click="cancel"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <SubmitButton @click="submit" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { errorMessageGenerator, prolongationModel } from '@/validators'
import { prolongateGuarantee } from '@/services'

export default {
  name: 'ProlongationForm',
  props: {
    guarantee: Object
  },
  data () {
    return {
      form: {
        documentUrl: '',
        expiryDate: '',
        comment: ''
      }
    }
  },
  computed: {},
  methods: {
    errorMessages (key) {
      return errorMessageGenerator(this.$v.form[key], key)
    },
    async submit () {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        await prolongateGuarantee(this.guarantee.contractId, this.guarantee.id, this.form)
        this.$emit('update')
        this.cancel()
      }
    },
    cancel () {
      this.form = {
        documentUrl: '',
        expiryDate: ''
      }
      this.$eventBus.$emit('CLOSE_MODAL')
    }
  },
  validations: prolongationModel
}
</script>
